(() => {
    const navigation = document.querySelector('.navigation-slide-out');
    const content = document.querySelector('.site-container__content');
    const footer = document.querySelector('.site-container__footer');

    const toggleNavigation = () => {
        const { height } = navigation.getBoundingClientRect();

        if (document.body.classList.contains('navigation-open')) {
            document.body.classList.remove('navigation-open');

            content.style.transform = `translateY(${0}px)`;
            footer.style.transform = `translateY(${0}px)`;
        } else {
            document.body.classList.add('navigation-open');

            content.style.transform = `translateY(${height}px)`;
            footer.style.transform = `translateY(${height}px)`;
        }
    };

    document
        .querySelector('.close-icon')
        .addEventListener('click', toggleNavigation);
    document
        .querySelector('.hamburger-icon')
        .addEventListener('click', toggleNavigation);
})();
